import { Inbox } from 'lucide-react';
import type { ReactNode } from 'react';

export function EmptyState({ title, message, icon, action }: {
  title: string; message?: string; icon?: ReactNode; action?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 px-6 py-14 text-center">
      <span className="flex h-12 w-12 items-center justify-center rounded-full bg-surface-2 text-ink-faint">
        {icon ?? <Inbox className="h-6 w-6" />}
      </span>
      <div>
        <p className="text-sm font-semibold text-ink">{title}</p>
        {message && <p className="mx-auto mt-1 max-w-sm text-sm text-ink-muted">{message}</p>}
      </div>
      {action}
    </div>
  );
}
